import { render, staticRenderFns } from "./FactorInvoiceDetail.vue?vue&type=template&id=a6495340&scoped=true"
import script from "./FactorInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./FactorInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./FactorInvoiceDetail.vue?vue&type=style&index=0&id=a6495340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6495340",
  null
  
)

export default component.exports